import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

gsap.registerPlugin(ScrollTrigger);

const ScrollRevealText = ({ text }) => {
  const textRef = useRef(null);

  useEffect(() => {
    if (!textRef.current) return;

    // Split text into lines
    const splitText = new SplitType(textRef.current, { types: "lines" });

    // Set each line as a block (to handle gaps correctly)
    splitText.lines.forEach((line) => {
      line.style.overflow = "hidden";
      line.style.display = "block";
    });

    // GSAP ScrollTrigger animation
    gsap.from(splitText.lines, {
      y: "100%",
      opacity: 0,
      stagger: 0.2,
      duration: 5,
      ease: "power3.out",
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 100%", // Adjust when the animation starts
        toggleActions: "play none none reverse", // Animation plays forward and reverses when scrolling up
      },
    });

    return () => splitText.revert(); // Cleanup on unmount
  }, []);

  return (
    <h4 className="tp-hero-3-title tp_reveal_anim " ref={textRef}>
      {text}
    </h4>
  );
};

export default ScrollRevealText;
